// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { CREATE_TRUCK, DELETE_TRUCK, GET_DETAIL_TRUCK, GET_LIST_TRUCK, UPDATE_TRUCK } from '~/utils/constants/actionType';
import { IFormTruck, IQueryParamTruck } from '~/utils/interface/truck';
import truckApi from '~/apis/truck';
import { IBodyUpdate } from '~/utils/interface/common';

export const getListTruck = createAsyncThunk(GET_LIST_TRUCK, async (params: IQueryParamTruck, { rejectWithValue }) => {
  try {
    const resp = await truckApi.getListTruck(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});


export const getDetailTruck = createAsyncThunk(GET_DETAIL_TRUCK, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await truckApi.getDetailTruck(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createTruck = createAsyncThunk(CREATE_TRUCK, async (body: IFormTruck, { rejectWithValue }) => {
  try {
    const resp = await truckApi.createTruck(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateTruck = createAsyncThunk(
  UPDATE_TRUCK,
  async (params: IBodyUpdate<IFormTruck>, { rejectWithValue }) => {
    try {
      const resp = await truckApi.updateTruck(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTruck = createAsyncThunk(DELETE_TRUCK, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await truckApi.deleteTruck(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
